import React, { useState } from 'react';
import './OverlayInterior.css';

const ambientes = [
  {
    nombre: 'Sala',
    img: process.env.PUBLIC_URL + '/imagenes/sala2.jpg',
    videoIndex: 7, // Apunta al nuevo sala2.mp4 (índice 7)
  },
  {
    nombre: 'Family Room',
    img: process.env.PUBLIC_URL + '/imagenes/sala.jpg',
    videoIndex: 3, // Family Room usa el video actual de sala.mp4
  },
  {
    nombre: 'Dormitorio',
    img: process.env.PUBLIC_URL + '/imagenes/dormitorio.jpg',
    videoIndex: 4, // Índice del video Dormitorio.mp4 en el array principal
  },
  {
    nombre: 'Terraza',
    img: process.env.PUBLIC_URL + '/imagenes/patio.jpg',
    videoIndex: 5, // Índice del video patio.mp4 en el array principal
  },
];

const OverlayInterior = ({ onContinue, setVideoFondo, showExploracion, setShowExploracion, onClose }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleBackClick = () => {
    if (showExploracion) {
      setShowExploracion(false);
    } else {
      onClose();
    }
  };

  return (
    <div className="overlay-interior">
      <div className={`overlay-interior-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
        <button className="overlay-back-btn" onClick={handleBackClick}>
          <span className="material-symbols-outlined">arrow_back</span>
        </button>

        <div className="overlay-interior-header">
          <button 
            className="overlay-toggle-btn" 
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <span className="material-symbols-outlined">
              {isExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}
            </span>
          </button>
        </div>

        <img
          src={process.env.PUBLIC_URL + '/Logo/logo-nuevo-Garden-1 1.png'}
          alt="Logo Garden"
          className="overlay-interior-logo"
        />

        {isExpanded && (
          <>
            {!showExploracion ? (
              <>
                <button className="overlay-interior-btn" onClick={() => setShowExploracion(true)}>
                  Explorar interiores
                </button>
              </>
            ) : (
              <div className="overlay-interior-explora">
                <h2 className="overlay-interior-explora-title">Explora los ambientes</h2>
                <div className="overlay-interior-ambientes">
                  {ambientes.map((amb, idx) => (
                    <button
                      key={amb.nombre}
                      className="overlay-interior-amb-btn"
                      onClick={() => setVideoFondo(amb.videoIndex)}
                    >
                      <img src={amb.img} alt={amb.nombre} className="overlay-interior-amb-img" />
                      <span>{amb.nombre}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default OverlayInterior; 